import listSagas from '../lists/sagas';
import careNeedSagas from '../careNeeds/sagas';

const sagas = [...listSagas, ...careNeedSagas];

export default sagas;
